module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starFilled@2x-586a788adfbe969c878045fb707a15aa.png";